import {
  GET_EXCO_PROVINSI,
  GET_EXCO_PROVINSI_SUCCESS,
  GET_EXCO_PROVINSI_FAIL,
} from "./actionTypes";
import { API } from "../../API/api";

export const getTableProvinsi = (param,page,search,sort,sortType) => (dispatch) => {
  dispatch({
    type: GET_EXCO_PROVINSI,
  });

  const request = API.getTableExco(param,page,search,sort,sortType);
  return request.then(
    (response) => dispatch(getTableProvinsiSuccess(response.data)),
    (err) => dispatch(getTableProvinsiFail(err))
  );
};

export const getTableProvinsiSuccess = (data) => (dispatch) => {
  return dispatch({
    type: GET_EXCO_PROVINSI_SUCCESS,
    payload: data,
  });
};

export const getTableProvinsiFail = (data) => (dispatch) => {
  return dispatch({
    type: GET_EXCO_PROVINSI_FAIL,
    payload: data,
  });
};
